export const render = (t: string) => {
  const el = document.createElement('div')
  el.innerHTML = t
  return el.firstChild as HTMLElement
}
